module.exports = __webpack_public_path__ + "img/avatar.21090dc8.png";